import getMessage from 'src/background/utils/i18n.utils';
import React, { useEffect, useRef, useState } from 'react';
import Select from 'react-dropdown-select';
import { CustomSelectItemComponent } from 'src/common-ui/custom-select/custom-select-item.component';
import { SVGIcons } from 'src/common-ui/icons.enum';
import { InputType } from 'src/common-ui/input/input-type.enum';
import InputComponent from 'src/common-ui/input/input.component';
import { SVGIcon } from 'src/common-ui/svg-icon/svg-icon.component';
export function ComplexeCustomSelect(itemProps) {
    const ref = useRef(null);
    const [filteredOptions, setFilteredOptions] = useState(itemProps.options);
    const [query, setQuery] = useState('');
    useEffect(() => {
        setFilteredOptions(filter(query));
    }, [query, itemProps.options]);
    const filter = (query) => {
        return itemProps.options.filter((option) => {
            var _a;
            return option.label.toLowerCase().includes(query.toLowerCase()) ||
                ((_a = option.subLabel) === null || _a === void 0 ? void 0 : _a.toLowerCase().includes(query.toLowerCase()));
        });
    };
    const customLabelRender = (selectProps) => {
        return (React.createElement("div", { className: "selected-item", onClick: () => {
                selectProps.methods.dropDown('close');
            } },
            itemProps.selectedItem.img && (React.createElement("img", { className: "left-image", src: itemProps.selectedItem.img })),
            React.createElement("span", null, itemProps.selectedItem.label)));
    };
    const customHandleRenderer = ({ props, state, methods, }) => {
        return (React.createElement(SVGIcon, { className: "custom-select-handle", icon: state.dropdown ? SVGIcons.SELECT_ARROW_UP : SVGIcons.SELECT_ARROW_DOWN }));
    };
    const customDropdownRenderer = ({ props, state, methods, }) => {
        var _a;
        setTimeout(() => {
            var _a;
            (_a = ref.current) === null || _a === void 0 ? void 0 : _a.focus();
        }, 200);
        return (React.createElement("div", { className: "custom-select-dropdown" },
            itemProps.filterable && (React.createElement(InputComponent, { onChange: setQuery, value: query, placeholder: '', type: InputType.TEXT, ref: ref, classname: "filter-input", rightActionIcon: itemProps.rightActionIcon ? SVGIcons.WALLET_SEARCH : undefined, rightActionClicked: (_a = itemProps.rightActionClicked) !== null && _a !== void 0 ? _a : undefined })),
            filteredOptions.map((option, index) => (React.createElement(CustomSelectItemComponent, { key: `option-${option.label}`, isLast: props.options.length === index, item: option, isSelected: option.value === itemProps.selectedItem.value, handleItemClicked: () => itemProps.setSelectedItem(option), closeDropdown: () => methods.dropDown('close'), onDelete: itemProps.onDelete, canDelete: option.canDelete })))));
    };
    return (React.createElement("div", { className: "custom-select-container" },
        itemProps.label && (React.createElement("div", { className: "label" }, itemProps.skipLabelTranslation
            ? itemProps.label
            : getMessage(itemProps.label))),
        React.createElement(Select, { values: [itemProps.selectedItem], options: itemProps.options, onChange: () => undefined, dropdownHandleRenderer: customHandleRenderer, contentRenderer: customLabelRender, dropdownRenderer: customDropdownRenderer, className: `custom-select ${itemProps.background ? itemProps.background : ''}` })));
}
